/**
 * After repeated failures of POST /notification/register/device, stop calling the API
 * until the counter is cleared (successful registration or device removal).
 */

export const DEVICE_REGISTRATION_FAILURE_COUNT_KEY =
  "DEVICE_REGISTRATION_FAILURE_COUNT";

export const MAX_DEVICE_REGISTRATION_FAILURES = 3;

export const getDeviceRegistrationFailureCount = (): number => {
  if (typeof window === "undefined") {
    return 0;
  }
  const raw = localStorage.getItem(DEVICE_REGISTRATION_FAILURE_COUNT_KEY);
  const n = parseInt(raw || "0", 10);
  return Number.isNaN(n) ? 0 : n;
};

export const isDeviceRegistrationBlockedByFailures = (): boolean =>
  getDeviceRegistrationFailureCount() >= MAX_DEVICE_REGISTRATION_FAILURES;

export const recordDeviceRegistrationApiFailure = (): void => {
  if (typeof window === "undefined") {
    return;
  }
  const next = getDeviceRegistrationFailureCount() + 1;
  localStorage.setItem(
    DEVICE_REGISTRATION_FAILURE_COUNT_KEY,
    String(next)
  );
};

export const clearDeviceRegistrationFailureCount = (): void => {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.removeItem(DEVICE_REGISTRATION_FAILURE_COUNT_KEY);
};
